// Browser-only contract kept separate from auth/transport for synthetic tests.
// The server independently validates the same limits before persisting.
export function buildFeatureRequestEvent(input = {}) {
  if (typeof input.requestId !== 'string' || !/^[A-Za-z0-9_-]{16,128}$/.test(input.requestId)) throw new Error('A valid request ID is required.')
  if (!['feature', 'improvement', 'issue'].includes(input.kind)) throw new Error('Choose a request type.')
  const description = typeof input.description === 'string' ? input.description.trim() : ''
  if (description.length < 10 || description.length > 2000 || /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/.test(description)) throw new Error('Describe your request in 10–2,000 characters.')
  const page = typeof input.page === 'string' ? input.page.split(/[?#]/, 1)[0] : ''
  if (!page || page.length > 300 || page.startsWith('//') || !/^\/[A-Za-z0-9/_~.%:@+-]*$/.test(page)) throw new Error('A valid app page is required.')
  const tab = typeof input.tab === 'string' ? input.tab.trim() : ''
  if (tab.length > 80 || /[\u0000-\u001f\u007f]/.test(tab)) throw new Error('The page tab must contain up to 80 characters.')
  return { type: 'feature_request', action: 'feature_request', level: 'info', message: description,
    path: page, data: { requestId: input.requestId, kind: input.kind, page, tab } }
}

export async function sendFeatureRequest(input, { user, getCurrentUser, fetchImpl = fetch }) {
  const event = buildFeatureRequestEvent(input)
  if (!user?.uid || typeof user.getIdToken !== 'function') throw new Error('Sign in before sending a feature request.')
  const token = await user.getIdToken()
  if (!token || getCurrentUser()?.uid !== user.uid) throw new Error('Your session changed. Sign in and try again.')
  const response = await fetchImpl('/api/log', { method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ events: [event] }) })
  let saved
  try { saved = await response.json() } catch { throw new Error('The app could not confirm that your request was saved. Try again.') }
  if (!response.ok) throw new Error(typeof saved?.error === 'string' ? saved.error : 'Your request could not be saved. Try again.')
  if (saved?.ok !== true || saved.count !== 1 || typeof saved.id !== 'string' || !/^feature_[a-f0-9]{64}$/.test(saved.id)) {
    throw new Error('The app could not confirm that your request was saved. Try again.')
  }
  return { id: saved.id }
}
